(() => {
  const content = document.querySelector('.article-template') || document.querySelector('.main-page-title');
  const main = content?.closest('main');
  const header = document.querySelector('.farma24-section-header');
  if (!main || !header || main.dataset.f24ArticleNavigation) return;
  main.dataset.f24ArticleNavigation = 'ready';

  let pending = false;
  const updateOffset = () => {
    pending = false;
    const style = getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    const persistent = ['sticky', 'fixed'].includes(style.position);
    const visible = style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
    const inset = Math.max(0, Number.parseFloat(style.top) || 0);
    const offset = persistent && visible ? rect.height + inset : 0;
    main.style.setProperty('--f24-article-anchor-offset', `${Math.ceil(offset + 16)}px`);
  };
  const scheduleUpdate = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(updateOffset);
  };

  updateOffset();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(scheduleUpdate).observe(header);
  document.fonts?.ready.then(scheduleUpdate);
})();
